<template>
  <div class="p-12">
    <div class="max-w-7xl mx-auto">
      <div class="space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500 capitalize">{{ $t('global.orders') }}</h4>
          <RouterLink
            :to="{ name: 'accounts.orders.create' }"
            class="btn btn-brand px-6 capitalize"
          >
            {{ $te('newOrder') ? $t('newOrder') : 'new order' }}
          </RouterLink>
        </div>

        <BaseDataIterator :service="fetchData">
          <!-- props
            data, fetchList
          -->
          <template #default="dataIteratorProps">
            <BaseDataTable :data="dataIteratorProps.data">
              <template #header>
                <ListHeader />
              </template>
              <template #default="{ item }">
                <ListItem :order="item" :key="item.uuid" />
              </template>
            </BaseDataTable>
          </template>
        </BaseDataIterator>
      </div>
    </div>
  </div>
</template>

<script>
import ListHeader from './components/ListHeader.vue';
import ListItem from './components/ListItem.vue';
import { accountOrdersClient } from '@/api/clients';

export default {
  components: {
    ListItem,
    ListHeader,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    fetchData(params = {}) {
      return accountOrdersClient.list(this.accountId, {
        ...params,
        include: ['supplier', 'customer', 'tags', 'status', 'invoice', 'projectsCount'],
      });
    },
  },
};
</script>
